import { useTranslation } from 'react-i18next';

import { DocsRail } from '../components/docs-shell-rail';
import { EndpointErrors } from '../components/endpoint-page/endpoint-errors';
import { EndpointHeader } from '../components/endpoint-page/endpoint-header';
import { EndpointParameters } from '../components/endpoint-page/endpoint-parameters';
import { EndpointRequestBody } from '../components/endpoint-page/endpoint-request-body';
import { EndpointRequirements } from '../components/endpoint-page/endpoint-requirements';
import { EndpointResponses } from '../components/endpoint-page/endpoint-responses';
import { EndpointSection } from '../components/endpoint-page/endpoint-section';
import { SnippetTabs } from '../components/snippet-tabs';
import { TryItPanel } from '../components/try-it/try-it-panel';
import type { DocsOperation } from '../generated/reference';

/**
 * `/docs/api/$tag/$operation` (plan 7): header and description, requirements, parameters,
 * request body, responses, code samples and errors. The try-it panel goes in the right rail.
 */
export function EndpointPage({ operation }: { operation: DocsOperation }) {
  const { t } = useTranslation('docs');
  return (
    <article className="mx-auto flex max-w-4xl flex-col gap-10">
      <EndpointHeader operation={operation} />
      <EndpointRequirements operation={operation} />
      <EndpointParameters operation={operation} />
      <EndpointRequestBody operation={operation} />
      <EndpointResponses operation={operation} />
      <EndpointSection id="code-samples" title={t('endpoint.snippets.title')}>
        <SnippetTabs operationId={operation.id} />
      </EndpointSection>
      <EndpointErrors operation={operation} />
      <DocsRail label={t('tryIt.title')} description={t('tryIt.description')} size="panel">
        <TryItPanel operation={operation} />
      </DocsRail>
    </article>
  );
}
